import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateFormatting'
})
export class DateFormattingPipe implements PipeTransform {

  transform(value: string): any {
    return value ? moment(value).locale('es').format('LLL') : null;
  }


}
